import { resolveComponent as _resolveComponent, vShow as _vShow, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "guests w-100" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "px-5"
}
const _hoisted_4 = {
  key: 0,
  class: "room-guests-title"
}
const _hoisted_5 = { class: "room-guests-title__text" }
const _hoisted_6 = { class: "room-guests-title__icon" }
const _hoisted_7 = { class: "guests-item-wrapper" }
const _hoisted_8 = { class: "guest-item d-flex justify-space-between align-center my-3" }
const _hoisted_9 = { class: "mr-2" }
const _hoisted_10 = { class: "text-body-2" }
const _hoisted_11 = {
  key: 1,
  class: "guests-item-wrapper"
}
const _hoisted_12 = { class: "guest-item d-flex justify-space-between align-center my-3" }
const _hoisted_13 = { class: "guests-item__description" }
const _hoisted_14 = { class: "text-body-2" }
const _hoisted_15 = { class: "text-caption font-weight-thin" }
const _hoisted_16 = {
  key: 2,
  class: "guests-item-wrapper"
}
const _hoisted_17 = { class: "guest-item d-flex justify-space-between align-center my-3" }
const _hoisted_18 = { class: "guests-item__description" }
const _hoisted_19 = { class: "text-body-2" }
const _hoisted_20 = { class: "text-caption font-weight-thin" }
const _hoisted_21 = {
  key: 1,
  class: "module__content"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_guests_selector = _resolveComponent("guests-selector")
  const _component_fa_icon = _resolveComponent("fa-icon")
  const _component_input_quantity = _resolveComponent("input-quantity")
  const _component_v_divider = _resolveComponent("v-divider")
  const _component_selected_room = _resolveComponent("selected-room")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!$props.roomStay.isBooked)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _withDirectives((_openBlock(), _createBlock(_component_guests_selector, {
            key: $data.guestsUpdateKey,
            "room-stay-index": $props.roomStayIndex,
            "room-stay": $props.roomStay,
            guests: $options.computedGuests,
            onChange: $options.onGuestsQuantityChange,
            onClear: _cache[0] || (_cache[0] = $event => ($options.clearGuests($event))),
            onRemove: $options.removeRoom
          }, null, 8, ["room-stay-index", "room-stay", "guests", "onChange", "onRemove"])), [
            [_vShow, $setup.isDesktop]
          ]),
          (!$setup.isDesktop)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                ($props.showRoomIndex)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("span", _hoisted_5, " Room #" + _toDisplayString($props.roomStayIndex + 1), 1),
                      _createElementVNode("span", _hoisted_6, [
                        (_ctx.bookingRequest.rooms > 1)
                          ? (_openBlock(), _createBlock(_component_fa_icon, {
                              key: 0,
                              icon: ['far', 'xmark'],
                              onClick: $options.removeRoom
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.isAdultsOnlyHotel
                    ? _ctx.$t('Search#Form#Field#NumPersonsPlural Persons')
                    : _ctx.$t('Search#Form#Field#NumAdultsPlural Adults')), 1)
                    ]),
                    ($data.adultsShow)
                      ? (_openBlock(), _createBlock(_component_input_quantity, {
                          key: 0,
                          min: $data.adultsMin,
                          max: $data.adultsMax,
                          default: $props.roomStay.adults,
                          onChange: _cache[1] || (_cache[1] = $event => (
                $options.onGuestsQuantityChange({
                  guestType: 'adults',
                  quantity: $event
                })
              ))
                        }, null, 8, ["min", "max", "default"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_v_divider)
                ]),
                (_ctx.$route.name !== 'package' && $data.childrenShow)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('Search#Form#Field#NumChildrenPlural Children')), 1),
                          _createElementVNode("div", _hoisted_15, [
                            (_ctx.childrenAgeRange.minAge)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(_ctx.$t(
                      'Search#Form#Field#GuestsAge {minAge}-{maxAge} years old',
                      _ctx.childrenAgeRange
                    )), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(_ctx.$t(
                      'Search#Form#Field#GuestsAge Under {maxAge} years old',
                      _ctx.childrenAgeRange
                    )), 1)
                                ], 64))
                          ])
                        ]),
                        _createVNode(_component_input_quantity, {
                          min: $data.childrenMin,
                          max: $data.childrenMax,
                          default: $props.roomStay.children,
                          onChange: _cache[2] || (_cache[2] = $event => (
                $options.onGuestsQuantityChange({
                  guestType: 'children',
                  quantity: $event
                })
              ))
                        }, null, 8, ["min", "max", "default"])
                      ]),
                      _createVNode(_component_v_divider)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.$route.name !== 'package' && $data.infantsShow)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('Search#Form#Field#NumInfantsPlural Infants')), 1),
                          _createElementVNode("div", _hoisted_20, [
                            (_ctx.infantsAgeRange.minAge)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(_ctx.$t(
                      'Search#Form#Field#GuestsAge {minAge}-{maxAge} years old',
                      _ctx.infantsAgeRange
                    )), 1)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(_ctx.$t(
                      'Search#Form#Field#GuestsAge Under {maxAge} years old',
                      _ctx.infantsAgeRange
                    )), 1)
                                ], 64))
                          ])
                        ]),
                        _createVNode(_component_input_quantity, {
                          min: $data.infantsMin,
                          max: $data.infantsMax,
                          default: $props.roomStay.infants,
                          onChange: _cache[3] || (_cache[3] = $event => (
                $options.onGuestsQuantityChange({
                  guestType: 'infants',
                  quantity: $event
                })
              ))
                        }, null, 8, ["min", "max", "default"])
                      ]),
                      _createVNode(_component_v_divider)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    ($props.roomStay.isBooked)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createVNode(_component_selected_room, {
            index: $props.roomStayIndex,
            onRemove: $options.removeRoom
          }, null, 8, ["index", "onRemove"])
        ]))
      : _createCommentVNode("", true)
  ]))
}